import { UI } from "../constants/tokens";
import { marketBadge } from "../utils/marketStatus";
import Icon from "./Icon";
import InfoTip from "./InfoTip";
import LTR from "./LTR";

// Times and durations inside the Hebrew text, isolated LTR.
const Iso = ({ text }) => String(text).split(/(\d[\d:]*)/).map((p, i) => (i % 2 ? <LTR key={i} className="si-num">{p}</LTR> : p));

// ─── The market's state, above the brief (sprint 19, stage 2) ───────────────
// New York's session as marketStatus.js computes it (the NYSE clock, holidays
// from Finnhub), and the next open on both clocks. The current time on both
// clocks is in the status bar at the foot of every screen. No colour: green and red are
// for a number's rise and fall only (VISION.md), and "open" is neither.
// `status` comes from useMarketStatus(), which re-renders every minute.
export default function MarketStateBadge({ status, now = new Date(), style }) {
  const b = marketBadge(status, now);
  return (
    <div data-market-badge={b.state} style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "4px 10px", fontSize: 12.5, color: UI.text.secondary, ...style }}>
      <span style={{
        display: "inline-flex", alignItems: "center", gap: 6, padding: "4px 10px", borderRadius: 999,
        background: UI.fill.subtle, color: UI.text.primary, fontWeight: 700, fontSize: 13,
      }}>
        <Icon name="clock" size={13} color={UI.text.secondary}/>
        <span><Iso text={b.text}/></span>
      </span>
      {b.detail && <span style={{ color: UI.text.muted }}><Iso text={b.detail}/></span>}
      <InfoTip label="על מצב המסחר" size={13}
        text="מצב המסחר בבורסה בניו יורק, לפי שעון ניו יורק ושעות המסחר הרגילות, ולוח החגים וימי המסחר המקוצרים של Finnhub. מצב המסחר בבורסה בתל אביב אינו מוצג: אין לו מקור חי באפליקציה."/>
    </div>
  );
}
